/**
 * chat_open_room_controller — one-shot bridge after Turbo room create/update.
 *
 * Turbo stream replaces `#chat-open-room` with an element that mounts this
 * controller. On connect it dispatches `chat:open-room` so Preact shells
 * (fullscreen ChatApp / dock DockApp) can open the room without a reload.
 */
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    roomId: { type: Number, default: 0 },
  }

  connect() {
    const roomId = this.roomIdValue
    if (!roomId) return

    window.dispatchEvent(new CustomEvent("chat:open-room", {
      detail: { roomId },
    }))
  }
}
